module.exports = __webpack_public_path__ + "static/media/logo_dark.9b725664.png";


//////////////////
// WEBPACK FOOTER
// ./src/branding/current/logo_dark.png
// module id = 20
// module chunks = 0